import React from 'react';
import styles from './PermitDocuments.module.scss';
import { Icon, Popover, Tooltip } from 'antd';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import usePermitDocuments from '../../api/usePermitDocuments';
import ContentDocsPermit from '../ContentDocsPermit/ContentDocsPermit';

const PermitDocuments = ({ permit, ...props }) => {
  const { data = [], isFetching } = usePermitDocuments(permit?.id, {
    enabled: !!permit?.id,
  });

  const hasDocs = !!data?.length && !isFetching;

  return (
    <Popover
      title="Документы пропуска"
      trigger="click"
      placement="right"
      content={
        <ContentDocsPermit
          permitId={permit?.id}
          data={data}
        />
      }
    >
      <Tooltip
        placement="topLeft"
        title={hasDocs ? 'Документы пропуска' : 'Добавить документы'}
      >
        <RoundedButton
          text={
            <Icon
              type={isFetching ? 'loading' : 'paper-clip'}
              style={{
                color: hasDocs ? '#3378F9' : '#888',
                fontSize: '18px',
              }}
            />
          }
          type="link"
          className={styles.customBtn}
          {...props}
        />
      </Tooltip>
    </Popover>
  );
};

export default PermitDocuments;
